<template>
    <div id="cuestionario">
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="18" class="titulo">
                Capacitación # {{ Comision.idComision }} - {{ Comision.Nombre }}
            </el-col>
        </el-row>
        <el-row :gutter="20" type="flex" justify="center" align="middle">
            <el-col :span="22" class="cuerpo">


                <!-- Respuestas Segundo Intento -->
                <div v-if="!visible && Pregunta.Intento==2"
                style="margin-top:30px; border:1px solid #ccc; padding:30px; font-size:18px; background-color:rgba(255,255,255,0.3)">
                    <center><strong>Preguntas Contestadas Recuperación</strong></center><hr>
                    <ol>
                        <li v-for="(item,index) in Intento2" :key="index">
                            <span :class="'color-' + item.Tipo">{{ item.Pregunta }}</span>
                        </li>
                    </ol>
                    <hr>
                    <small><i>{{ Correctas2 }} / 7 Respuestas Correctas.</i></small>
                    <hr>
                    <center><strong>{{ Estado2 }}</strong></center>
                </div>


                <!-- Respuestas Primer Intento -->
                <div v-if="!visible && Pregunta.Intento==1" 
                style="margin-top:30px; border:1px solid #ccc; padding:30px; font-size:18px; background-color:rgba(255,255,255,0.3)">
                    <center><strong>Preguntas Contestadas</strong></center><hr>
                    <ol>
                        <li v-for="(item,index) in Intento1" :key="index">
                            <span :class="'color-' + item.Tipo">{{ item.Pregunta }}</span>
                        </li>
                    </ol>
                    <hr>
                    <small><i>{{ Correctas1 }} / 7 Respuestas Correctas.</i></small>
                    <hr>                    
                    <center><strong>{{ Estado1 }}</strong></center>
                </div>


                <!-- Pregunta -->
                <div v-if="visible" style="margin-top:30px; font-size:20px">
                    <center>
                        Pregunta {{ Pregunta.cantidad + 1 }} de 7 <br><br>
                        <strong>{{ Pregunta.Pregunta }}</strong>
                    </center><br><br>
                    <el-radio v-model="Respuesta" :label="Respuestas[0].id" border>{{ Respuestas[0].Respuesta }}</el-radio><br><br>
                    <el-radio v-model="Respuesta" :label="Respuestas[1].id" border>{{ Respuestas[1].Respuesta }}</el-radio><br><br>
                    <el-radio v-model="Respuesta" :label="Respuestas[2].id" border>{{ Respuestas[2].Respuesta }}</el-radio><br><br>
                    <el-radio v-model="Respuesta" :label="Respuestas[3].id" border>{{ Respuestas[3].Respuesta }}</el-radio><br><br><br>
                    <v-col class="col-12">
                        <v-btn 
                            raised 
                            block
                            color="green" 
                            :loading="cargando" 
                            @click="Submit()"
                            style="color:#fff"
                        >
                            Siguiente
                        </v-btn>
                    </v-col>
                </div>
                <div v-if="!visible" style="margin-top:30px; background:orange; text-align:center; font-size:x-large; padding:20px">
                    Gracias por Responder el Cuestionario
                </div>

            </el-col>
        </el-row>
    </div>
</template>



<script>
    import axios from 'axios'

    export default
    {   data()
        {   return {
                idComisionEncriptada:   this.$route.params.id,
                idComision:             atob(this.$route.params.id),
                Comision:               [],
                Intento1:               [],
                Intento2:               [],
                Respuestas:             [],
                Pregunta:               [],
                Estado1:                '',
                Estado2:                '',
                Respuesta:              '',
                Correctas1:             0,
                Correctas2:             0,
                cargando:               false,
                visible:                true,
            }
        },


        methods:
        {   SumarRespuestasCorrectas(arreglo)
            {   var suma = 0;
                if(arreglo)
                {   for(var i=0; i<arreglo.length; i=i+1)
                    {   if(arreglo[i].Tipo==1)
                            suma = suma + 1;                
                    }
                }
                return suma;
            },
            
            
            Submit()
            {   if(this.Respuesta)
                {   this.cargando   = true;
                    var params      = '';
                    var headers     = new Headers();
                    headers.append('Content-Type', 'application/x-www-form-urlencoded');
                    
                    params = params + 'tkn=' + this.$cookies.get('PDTK');
                    params = params + '&idComision=' + this.idComisionEncriptada;
                    params = params + '&idCuestionario=' + btoa(this.Pregunta.idDPR);
                    params = params + '&idRespuesta=' + btoa(this.Respuesta);
                    
                    axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/quest_in.php', params, {headers: headers})
                        .then(response => {
                            var params  = '';
                            var headers = new Headers();
                            headers.append('Content-Type', 'application/x-www-form-urlencoded');
                            
                            params = params + 'tkn=' + this.$cookies.get('PDTK');
                            params = params + '&idComision=' + this.idComisionEncriptada;
                            
                            axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/quest_dt.php', params, {headers: headers})
                                .then(response => {
                                    const datos                 = response.data;
                                    this.Intento1               = datos['Intento1'];
                                    this.Intento2               = datos['Intento2'];
                                    this.Pregunta               = datos['Pregunta'];
                                    this.Respuestas             = datos['Respuestas'];
                                    this.cargando               = false;
                                    if(!this.Intento2 && this.Intento1.length>=7) 
                                    {   this.Correctas1         = this.SumarRespuestasCorrectas(this.Intento1);
                                        this.visible            = false;
                                        this.Pregunta.Intento   = 1;
                                        if(this.Correctas1>=5)  this.Estado1 = 'Aprobado';
                                        else                    this.Estado1 = 'Desaprobado';
                                    }
                                    if(this.Intento2.length>=7) 
                                    {   this.Correctas2         = this.SumarRespuestasCorrectas(this.Intento2);
                                        this.visible            = false;
                                        this.Pregunta.Intento   = 2;
                                        if(this.Correctas2>=5)  this.Estado2 = 'Aprobado';
                                        else                    this.Estado2 = 'Desaprobado';
                                    }                                     
                                })
                                .catch(e => {})
                        })
                        .catch(e => {})
                }
                else
                {   alert('Por favor, elija una opción antes de continuar');
                }
            }   
        },


        beforeMount( )
        {   if (!this.$cookies.get('PDTK'))
            {   this.$router.push('../login');
            }
            else
            {   var params  = '';
                var headers = new Headers();
                headers.append('Content-Type', 'application/x-www-form-urlencoded');
                
                params = params + 'tkn=' + this.$cookies.get('PDTK');
                params = params + '&idComision=' + this.idComisionEncriptada;
                
                axios.post('https://docentes.educaciondigitaltuc.gob.ar/aphpi/quest_dt.php', params, {headers: headers})
                    .then(response => {
                        const datos                 = response.data
                        this.Comision               = datos['Comision'];
                        this.Intento1               = datos['Intento1'];
                        this.Intento2               = datos['Intento2'];
                        this.Pregunta               = datos['Pregunta'];
                        this.Respuestas             = datos['Respuestas'];                        
                        this.Correctas1             = this.SumarRespuestasCorrectas(this.Intento1);
                        this.Correctas2             = this.SumarRespuestasCorrectas(this.Intento2);
                        if(!this.Comision)          this.$router.push('/cuestionarios');
                        if(!this.Pregunta)          this.$router.push('/cuestionarios');
                        if(!this.Respuestas)        this.$router.push('/cuestionarios');
                        if(this.Intento1.length>=7 && this.Intento2.length>=7) 
                        {   this.visible            = false;
                            this.Pregunta.Intento   = 2;
                        }
                    })
                    .catch(e => {})
            }
        }
    };
</script>



<style>
    .color-0
    {   font-weight: bold;
        color: red;
    }

    .color-1
    {   font-weight: bold;
        color: green;
    }

    .el-radio__label
    {   font-size: 18px;
    }
</style>